// extracted by css-extract-rspack-plugin
export default {"section":"section-LmC7eT","sectionToggle":"sectionToggle-FQBuIK","title":"title-NqEHNV"};